import React, { useEffect, useRef } from "react";

// Scroll-reveal wrapper using IntersectionObserver
export const Reveal = ({ children, className = "", delay = 0, as: Tag = "div" }) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => entry.target.classList.add("in-view"), delay);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [delay]);
  return (
    <Tag ref={ref} className={`reveal ${className}`}>
      {children}
    </Tag>
  );
};

export const SectionHeading = ({ eyebrow, title, accent, align = "left", light = false }) => (
  <div className={align === "center" ? "text-center max-w-2xl mx-auto" : ""}>
    {eyebrow && (
      <div className={`eyebrow mb-5 ${align === "center" ? "flex items-center justify-center gap-3" : "flex items-center gap-3"}`}>
        <span className="inline-block w-8 h-px bg-[var(--gold)]" />
        {eyebrow}
      </div>
    )}
    <h2 className="font-serif-display text-4xl md:text-5xl lg:text-[3.4rem] leading-[1.05] tracking-tight">
      {title} {accent && <span className="gold-text italic">{accent}</span>}
    </h2>
  </div>
);
